import moment from 'moment'
import { DATE_PICKER_FREQUENCIES } from 'uiKit/DateControlNew/DateControl'

export type DashboardDateApiParams = {
  fromDate?: string
  toDate?: string
  isDefault?: boolean
}

export const getDashboardDateApiParams = (
  frequency: string | null,
  startDate?: moment.Moment,
  endDate?: moment.Moment,
  isCarecoAdmin = false,
): DashboardDateApiParams => {
  const params: DashboardDateApiParams = {
    fromDate: startDate?.format('YYYY-MM-DD'),
    toDate: endDate?.format('YYYY-MM-DD'),
  }

  if (isCarecoAdmin && frequency === DATE_PICKER_FREQUENCIES.default) {
    params.isDefault = true
  }

  return params
}

export const shouldShowAccountStatusForDateRange = (
  isCarecoAdmin: boolean,
  frequency: string | null,
): boolean => !isCarecoAdmin || !isDashboardDefaultDateRange(frequency)

export const isDashboardDefaultDateRange = (frequency: string | null): boolean =>
  frequency === DATE_PICKER_FREQUENCIES.default
